import { z } from "zod";

export const topicNarrationProviderSchema = z.enum([
	"ELEVENLABS",
	"FISH_SPEECH",
]);

export type TopicNarrationProvider = z.infer<
	typeof topicNarrationProviderSchema
>;

export const DEFAULT_TOPIC_NARRATION_PROVIDER = "FISH_SPEECH" as const;

export const NARRATION_CHUNK_LIMIT_BY_PROVIDER: Record<
	TopicNarrationProvider,
	number
> = {
	ELEVENLABS: 5000,
	FISH_SPEECH: 2000,
};
